import { Component, EventEmitter, Input, Output } from '@angular/core';
import paginate from 'jw-paginate';
import { ITEMS_PER_PAGE } from '../constant/constant';

@Component({
    selector: 'ddc-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    standalone: false
})
export class PaginationComponent {

  @Input() set nbreItems(nbreItems: number) {
    this._nbreItems = nbreItems;
    // Initialize the pager when receiving the the total number of pages from the parent component
    this.initPager();
  }

  @Input() set itemsPerPage(itemsPerPage: number|null ) {
    itemsPerPage ? this._itemsPerPage = itemsPerPage : this.itemsPerPage = ITEMS_PER_PAGE;
    // Initialize the pager when receiving the the total number of pages from the parent component
    this.initPager();
  }

  @Output() pageChanged = new EventEmitter<any>();

  _nbreItems: number;
  pager: any;
  currentPage: number = 1;
  _itemsPerPage: number;

  initPager(pageNumber?: number): void {
    this.pager = paginate(this._nbreItems, pageNumber ? pageNumber : this.currentPage, this._itemsPerPage);
  }

  setPage(pageNumber) {
    // Launch an action just if the selected page is changed
    if (pageNumber !== this.currentPage) {
      this.initPager(pageNumber);
      this.currentPage = pageNumber;
      this.pageChanged.emit(pageNumber);
    }
  }
}
